import ImageSlider from "./ImageSlider";
import { IMAGES_DATA } from "../services/ImagesData";
import { useWrapperContext } from "../context/WrapperContext";
const TryonResultSlider = () => {
    const { productHandle } = useWrapperContext();
    const images =
        IMAGES_DATA?.[productHandle]?.url || [];
    return (
        images.length > 0 ? (
            <ImageSlider>
                {images.map((el, index) => (
                    <div key={index} className="outline-none slider">
                        <img
                            className="aspect-[2/2.5] !inline-block w-full object-cover"
                            src={el}
                            alt="img"
                        />
                    </div>
                ))}
            </ImageSlider>
        ) : null
    );
       
};

export default TryonResultSlider;